import NotificationIcon from '../../../../assets/icons/notification.svg?react';
import CloseIcon from '../../../../assets/icons/circle-close.svg?react';
import { WarngingBadgeStyled } from '../../style';
import React from 'react';

interface WarningBadgeProps {
  onClose: () => void;
  isOpen: boolean;
  icon?: React.ReactNode;
  message?: string;
}
export const WarningBadge = ({
  onClose,
  isOpen,
  icon = <CloseIcon />,
  message = `The source of report has been updated. Please update the report (click
	"Regenerate Report") to sync with latest changes. Your previous report
	will be overwritten.`,
  ...props
}: WarningBadgeProps) => {
  if (!isOpen) return <></>;

  return (
    <WarngingBadgeStyled id="report-warning-badge" {...props}>
      <NotificationIcon />
      <p id="report-warning-badge-message" dangerouslySetInnerHTML={{ __html: message }} />

      <button id="report-warning-badge-close-button" onClick={onClose}>
        {icon}
      </button>
    </WarngingBadgeStyled>
  );
};
